"use client"

import React, { useEffect, useState } from "react"
import Cookies from "js-cookie"
import { X } from "lucide-react"

const NOTICE_COOKIE_NAME = "cookie_notice_seen"
const NOTICE_EXP_DAYS = 365 // 1 год

export default function CookieConsent() {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        try {
            const noticeSeen = Cookies.get(NOTICE_COOKIE_NAME)
            const legacyNoticeSeen = ["analytics", "essential", "1"].includes(Cookies.get("cookie_consent") || "")
            if (noticeSeen !== "1" && !legacyNoticeSeen) {
                setIsOpen(true)
            }
        } catch {
            // В редких случаях доступ к куки может быть недоступен — просто не показываем
            setIsOpen(false)
        }
    }, [])

    // Both buttons dismiss an informational notice; neither controls Metrica.
    const dismiss = () => {
        try {
            Cookies.set(NOTICE_COOKIE_NAME, "1", {
                expires: NOTICE_EXP_DAYS,
                sameSite: "Lax",
                secure: typeof window !== "undefined" && window.location.protocol === "https:",
                path: "/",
            })
        } finally {
            setIsOpen(false)
        }
    }

    if (!isOpen) return null

    return (
        <section
            aria-label="Cookie"
            className="fixed bottom-[calc(72px+env(safe-area-inset-bottom))] left-2 right-2 z-40 flex items-center gap-1 rounded-xl bg-[#0B0B0B] py-1 pl-3 pr-1 text-white shadow-xl md:bottom-4 md:left-auto md:right-4 md:w-[420px]"
        >
            <p className="min-w-0 flex-1 text-[11px] leading-[15px] text-white/85">
                Используем cookie и Яндекс Метрику.{" "}
                <a href="/pages/politika-konfidentsialnosti/" className="underline underline-offset-2 hover:text-white">
                    Подробнее
                </a>
            </p>
            <button
                type="button"
                onClick={dismiss}
                className="h-10 shrink-0 rounded-lg bg-[#1A73FF] px-3 text-xs font-semibold hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
            >
                Ок
            </button>
            <button
                type="button"
                onClick={dismiss}
                aria-label="Закрыть уведомление о cookie"
                className="grid h-10 w-9 shrink-0 place-items-center rounded-lg text-white/70 hover:bg-white/10 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
            >
                <X className="h-4 w-4" aria-hidden="true" />
            </button>
        </section>
    )
}
